import BundleDetail from "./BundleDetail";
import * as promotionActions from "../../../../../actions/promotionAction";
import { connect } from "react-redux";

const mapStateToProps = state => {
    return {
        promotionState: state.promotionReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllCampaign: () => dispatch(promotionActions.getAllCampaign()),
        createBundlesDetails: (bundles) => dispatch(promotionActions.createBundlesDetails(bundles)),
        getBundlesDetails: (id) => dispatch(promotionActions.getBundlesDetails(id)),
        updateBundlesDetails: (bundle) => dispatch(promotionActions.updateBundlesDetails(bundle)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BundleDetail);
